module.exports = __webpack_public_path__ + "static/media/vantagens.761883a2.svg";